import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { objectToFormData } from "../../utils";
import PasswordIcon from "../../assets/icons/password.svg";
import * as yup from "yup";
import { Form, Input, Button, Typography, message } from "antd";
import {
  resetPassword,
  ResetPassword as ResetPasswordType,
} from "../../actions/auth";
import { useHistory } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import PasswordCheck from "../Common/PasswordCheck";
import { useFormik } from "formik";

const { Text, Title } = Typography;

message.config({
  maxCount: 3,
});

const ValidationSchema = yup.object().shape({
  password: yup.string().required("Password is required").min(12),
  password_confirmation: yup
    .string()
    .trim()
    .required("Password Confirmation is required")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

const ResetPassword = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [token, setToken] = React.useState("");
  const [passwordCheck, setPasswordCheck] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      password: "",
      password_confirmation: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (vals) => {
      vals.reset_password_token = token;
      dispatch(resetPassword(objectToFormData({ ...vals })));
    },
  });
  const resetPasswordResponse = useSelector(
    (state) => state.auth.resetPassword || {},
  );

  React.useEffect(() => {
    const url = window.location.search;
    const searchParams = new URLSearchParams(url);
    setToken(searchParams.get("token"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      resetPasswordResponse;
    if (status) {
      history.push("/");
    } else if (status === false) {
      dispatch({
        type: ResetPasswordType.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetPasswordResponse]);

  return (
    <div className="reset-form">
      <div className="head-sec">
        <div className="icon-background">
          <img
            src={PasswordIcon}
            alt={"PasswordIcon"}
            className="passwordIcon"
          />
        </div>
        <Title level={3} className="mt2" style={{ color: "#fff" }}>
          Set your password
        </Title>
        <Text className="text-dim" style={{ color: "#fff" }}>
          Please create a new password below. Your new password needs to have a
          minimum of 12 characters.
        </Text>
      </div>
      <Form onFinish={formik.handleSubmit} layout="vertical">
        <Form.Item
          label={<span style={{ color: "#fff" }}>New Password</span>}
          placeholder="Enter New Password"
          className="white-label-form"
        >
          <Input.Password
            placeholder="Enter password"
            name="password"
            onChange={formik.handleChange}
          />
          <PasswordCheck
            password={formik.values.password}
            setPasswordCheck={setPasswordCheck}
          />
          <div className="errorMsg">
            {formik.touched.password && formik.errors.password}
          </div>
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>Confirm New Password</span>}
          placeholder="Enter New Password"
        >
          <Input.Password
            placeholder="Enter password"
            name="password_confirmation"
            onChange={formik.handleChange}
          />
          <div className="errorMsg">
            {formik.touched.password_confirmation &&
              formik.errors.password_confirmation}
          </div>
        </Form.Item>

        <Button
          htmlType="submit"
          className="primaryButton mt2"
          disabled={passwordCheck || resetPasswordResponse?.loading}
        >
          {/* {resetPasswordResponse?.loading ? (
            <ClipLoader
              loading={resetPasswordResponse?.loading}
              size={10}
            />
          ) : (
            "Set Password"
          )} */}
          Set Password
        </Button>
      </Form>
      <div className="mt4 flex-center">
        <span className="text-dim footer-note" style={{ color: "#fff" }}>
          Unable to change password? Contact Support
          {/* , Phone: <a href="tel:+91 7400088941">+91 7400088941</a>{" "},
          Email: <a href="mailto:customercare@paycraftsol.com">customercare@paycraftsol.com</a> */}
        </span>
      </div>
    </div>
  );
};

export default ResetPassword;
